import React, { Component } from "react";
import mapboxGl from "mapbox-gl-latest";
import "mapbox-gl-latest/dist/mapbox-gl.css";
import moment from "moment";
import DopplerLegend from "./DopplerLegend";

mapboxGl.accessToken = process.env.REACT_APP_MAPBOX_TOKEN;

class DopplerVmiDbzMap extends Component {
  constructor(props) {
    super(props);
    // Defines the bottom middle point of map at intialization
    this.state = {
      latitude: 36.52,
      longitude: 12.39,
      zoom: 4.75,
      frameCount: props.dopplerFrequency,
      currentImageIndex: 0,
      intervalId: null,
      dateOfEvent: moment(this.props.dateOfEvent).format("YYYYMMDD"),
    };
  }

  getImage(currentImageIndex) {
    let subdir = "doppler";
    if (this.state.frameCount !== 12) {
      subdir += this.state.frameCount;
    }
    return `https://s3.eu-west-1.amazonaws.com/cys-data-platform/${subdir}/${this.state.dateOfEvent}/${currentImageIndex}.png`;
  }

  componentDidMount() {
    let currentState = this;
    const map = new mapboxGl.Map({
      container: this.mapContainer,
      style: "mapbox://styles/mapbox/dark-v9",
      center: [this.state.longitude, this.state.latitude],
      zoom: this.state.zoom,

      // "equirectangular" and equalEarth work equally well.
      // "mercator" and "globe" cause distortion at the middle (in south-north sense) part of the map
      // so that image is shifted about 48 km to the North in Rome, but around 33 km to the North in Palermo or Trieste.
      // To detect this one has to create specially crafted image with a grid and compare it with the map.
      // One must use "mapbox-gl-latest" (2.10) here because it has projections missing  in "mapbox-gl" (1.12).
      projection: "equirectangular",
    });

    map.on("load", function () {
      map.addSource("afterImageSource", {
        type: "image",
        url: currentState.getImage(currentState.state.currentImageIndex),
        coordinates: [
          // These coordinate are from TIFF file.
          [4.523391512, 47.848989216],
          [20.476608488, 47.848989216],
          [20.476608488, 35.065085777],
          [4.523391512, 35.065085777],
        ],
      });
      map.addLayer({
        id: "overlay",
        source: "afterImageSource",
        type: "raster",
        paint: {
          "raster-opacity": 0.85,
        },
      });

      new mapboxGl.Marker().setLngLat([currentState.props.longitude, currentState.props.latitude]).addTo(map);

      let intervalId = setInterval(function () {
        let index = (currentState.state.currentImageIndex + 1) % currentState.state.frameCount;

        map.getSource("afterImageSource").updateImage({
          url: currentState.getImage(index),
        });

        currentState.setState({
          currentImageIndex: index,
        });
      }, 800);

      currentState.setState({ intervalId });
    });
  }

  componentWillUnmount() {
    clearInterval(this.state.intervalId);
  }

  render() {
    const index = parseInt(this.state.currentImageIndex, 10);
    const duration = moment.duration((60 * 24 * index) / this.state.frameCount, "minutes");
    const hours = Math.floor(duration.asHours());
    const minutes = Math.floor(duration.minutes());
    const timeStep = `${hours.toString().padStart(2, "0")}:${minutes.toString().padStart(2, "0")}`;

    return (
      <div>
        <div
          ref={(el) => (this.mapContainer = el)}
          style={{
            right: 0,
            width: "100%",
            height: "100vh",
          }}
        />
        <DopplerLegend imageIndex={this.state.currentImageIndex} imageTime={timeStep + " UTC"} />
      </div>
    );
  }
}
export default DopplerVmiDbzMap;
